var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"preloader"},[_c('img',{attrs:{"src":require('../assets/img/loader_6.svg')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }